import axios, { AxiosInstance } from 'axios';

/** Utils */
import { getStorage, disableEncryption } from '@/utils/general-utils';

/** Services */
import { EncryptService } from '@/services/encrypt.service';

export class AxiosService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = process.env.VUE_APP_API_URL;
  }

  instance(): AxiosInstance {
    const instance = axios.create({
      baseURL: this.baseUrl,
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        Authorization: `Bearer ${getStorage('token')}`,
      },
    });

    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (!disableEncryption() && typeof error.response?.data === 'string') {
          error.response.data = EncryptService.decrypt(error.response.data);
        }
        return Promise.reject(error);
      }
    );

    return instance;
  }

  mock(): AxiosInstance {
    return axios.create({
      baseURL: '',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        Authorization: `Bearer ${getStorage('token')}`,
      },
    });
  }
}
